export default {
  Auth: {
    Cognito: {
    userPoolId: process.env.VITE_AWS_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.VITE_AWS_COGNITO_USER_POOL_WEB_CLIENT_ID,
      loginWith: {
        email: true,
        username: true,
        phone: false
      }
    }
  },
  API: {
    REST: {
      'go-transfer-projects': {
        endpoint: process.env.VITE_AWS_LAMBDA_TRANSFER_ENDPOINT,
        region: process.env.VITE_AWS_LAMBDA_TRANSFER_REGION
      }
    }
  }
};
